import { jsx as _jsx } from "react/jsx-runtime";
import { Children, useRef, useState, useEffect, isValidElement } from 'react';
import './CallToAction.scss';
const CallToActionMain = ({ children }) => {
    return _jsx("div", { className: "cta-main", children: children });
};
const CallToActionAside = ({ children }) => {
    return _jsx("div", { className: "cta-aside", children: children });
};
const CallToActionTitle = ({ children }) => {
    return _jsx("h1", { className: "cta-title", children: children });
};
const CallToActionPrompt = ({ children }) => {
    return _jsx("p", { className: "cta-prompt", children: children });
};
export const CallToAction = ({ children, className, step, vertline = false, hardSignalling = false, clickableLabels = false, onInputValidate = () => { return false; } }) => {
    const ctaId = useRef(`cta-${Math.random().toString(36).slice(2)}`);
    const [dirty, setDirty] = useState(false);
    const inputValid = onInputValidate();
    const columnCount = Children.toArray(children).filter(isValidElement).length;
    const onClickLabel = (e) => {
        if (!clickableLabels || !e)
            return;
        const label = e.currentTarget;
        const sibling = label === null || label === void 0 ? void 0 : label.previousElementSibling;
        const isInput = sibling instanceof HTMLInputElement;
        if (isInput && ['radio', 'checkbox'].some((t) => { return (sibling === null || sibling === void 0 ? void 0 : sibling.type) === t; })) {
            sibling.click();
        }
    };
    const onInputChange = () => {
        setDirty(true);
    };
    const getInputElements = () => {
        return document.querySelectorAll(`#${ctaId.current} .stage :is(input, textarea, select, input[type="radio"], input[type="checkbox"])`);
    };
    const getClickableLabels = () => {
        return document.querySelectorAll(`#${ctaId.current} .stage :is(input[type="radio"], input[type="checkbox"]) ~ label`);
    };
    const addEventListeners = () => {
        getInputElements().forEach(input => input.addEventListener('click', onInputChange));
        getClickableLabels().forEach(label => label.addEventListener('click', onClickLabel));
    };
    const removeEventListeners = () => {
        getInputElements().forEach(input => input.removeEventListener('click', onInputChange));
        getClickableLabels().forEach(label => label.removeEventListener('click', onClickLabel));
    };
    useEffect(() => {
        addEventListeners();
        return removeEventListeners;
    }, []);
    const clsxInputValidation = inputValid === null ? ''
        : (inputValid ? 'input-valid'
            : (hardSignalling ? 'input-invalid'
                : ''));
    const clsx = [
        'call-to-action',
        columnCount === 2 ? 'two-col' : 'one-col',
        step ? `step${step}` : '',
        clickableLabels ? 'clickable-labels' : '',
        vertline ? 'vertline' : '',
        dirty ? 'dirty' : '',
        clsxInputValidation,
        className !== null && className !== void 0 ? className : ''
    ].join(' ').trim();
    return (_jsx("section", { className: clsx, id: ctaId.current, children: _jsx("div", { className: "page-dim", children: _jsx("div", { className: "stage", children: children }) }) }));
};
CallToAction.Main = CallToActionMain;
CallToAction.Aside = CallToActionAside;
CallToAction.Title = CallToActionTitle;
CallToAction.Prompt = CallToActionPrompt;
